import { KeyedArray } from "@repo/models";

class SearchResult<T extends ISearchable> {
	search: string;
	matches: T[];
}

export interface ISearchable {
	text: string;
}

export class SearchResults<T extends ISearchable> {
	items: T[];
	searchResults: KeyedArray<SearchResult<T>>;

	constructor(items: T[]) {
		this.items = items;
		this.searchResults = new KeyedArray<SearchResult<T>>([], (i) => i.search);
	}

	search(search: string) {
		const currItems = this.searchResults.get(search);
		if (currItems) return currItems.matches;
		const priorSearch = this.getPriorSearches(search);
		const matches = priorSearch.filter((t) => t.text.toLowerCase().includes(search.toLowerCase()));

		const result = { search, matches };

		this.searchResults.set(result);
		return matches;
	}

	private getPriorSearches(search: string): T[] {
		const prevSearch = search.slice(0, search.length - 1);

		const prevItems = this.searchResults.get(prevSearch);
		if (prevItems) return prevItems.matches;
		if (prevSearch) return this.getPriorSearches(prevSearch);

		return this.items;
	}
}
